<template>
  <div class="not-found">
    <div class="not-found__top-bar">
      <Beacon class="not-found__beacon" />
    </div>
    <div class="not-found__container">
      <div class="not-found__content">
        <TenderLogo class="not-found__tender-logo" width="145" />

        <h1 class="not-found__title">{{ $t('not-found.title') }}</h1>
        <p class="not-found__text">
          <strong>{{ $t('not-found.subtitle1') }}</strong>
        </p>
        <p class="not-found__text">{{ $t('not-found.subtitle2') }}</p>

        <div class="not-found__buttons">
          <BaseButton :to="home" class="not-found__button" has-icon-right>
            {{ $t('not-found.btn1') }}
            <BaseIcon name="arrow-right" />
          </BaseButton>
          <BaseButton :to="tenders" class="not-found__button" has-icon-right is-outlined>
            {{ $t('not-found.btn2') }}
            <BaseIcon name="arrow-right" />
          </BaseButton>
        </div>
      </div>
      <NotFoundLogo class="not-found__image" height="403" />
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseIcon from '@/components/base/BaseIcon';
import Beacon from '@/components/Beacon';
import NotFoundLogo from '@/assets/images/404.svg';
import TenderLogo from '@/assets/images/aloha-logo.svg';

export default {
  name: 'PageNotFound',
  components: {
    BaseButton,
    BaseIcon,
    Beacon,
    NotFoundLogo,
    TenderLogo,
  },
  computed: {
    home() {
      return {
        name: 'home',
      };
    },
    tenders() {
      return {
        name: 'tenders',
      };
    },
  },
};
</script>

<style lang="scss">
.not-found {
  align-items: center;
  background-color: $color-white;
  display: flex;
  flex-direction: column;
  min-height: var(--viewport-height);
  padding: 32px;
  width: 100%;

  &__top-bar {
    display: flex;
    max-width: 450px;
    width: 100%;
  }

  &__beacon {
    margin-left: auto;
  }

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    max-width: 450px;
    width: 100%;
  }

  &__tender-logo {
    color: $color-brand-500;
    margin-bottom: 40px;
  }

  &__title {
    margin: 0 0 24px;
  }

  &__text {
    font-size: $font-size-small;
    margin-bottom: 16px;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
  }

  &__button {
    margin-top: 24px;
  }

  &__image {
    height: auto;
    margin-top: 40px;
    width: 200px;
  }
}

@media screen and (min-width: 784px) {
  .not-found {
    &__top-bar {
      max-width: initial;
    }

    &__container {
      flex-direction: row;
      max-width: 784px;
    }

    &__content {
      margin-right: 32px;
    }

    &__buttons {
      align-items: center;
      display: flex;
      flex-direction: row;
      margin-top: 40px;
    }

    &__button {
      margin-right: 16px;
      margin-top: 0;
    }

    &__image {
      margin-left: auto;
      margin-top: 0;
      width: auto;
    }
  }
}
</style>
